import { useStore } from 'zustand';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { AllSearchResults } from '@/app/(main)/_components/search-modal/search-modal.types';
import { resolveActiveFilter, resolveFilterTabs } from '@/app/(main)/_components/search-modal/_utils/search-filter-tabs.util';
import { FiltersTabs } from '@/components/ui/filters-tab.component';
import { setSelectedFilter, useSearchState } from '@/store/search/search.store';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { SelectedProcedures } from '@/app/(main)/_components/search-modal/search-modal.types';
import { OverridedUserLocation } from '@/utils/formatters/city/format-place-from-slug.const';

interface SearchFiltersProps {
  results: AllSearchResults;
  locationOverride?: OverridedUserLocation;
  className?: string;
  selectLaboratoryProcedure?: (procedure: SelectedProcedures) => void;
}

export function SearchFilters({
  results,
  className,
}: SearchFiltersProps) {
  const selectedFilter = useStore(useSearchState, (state) => state?.selectedFilter);
  const tabs = resolveFilterTabs(results);
  const activeTab = resolveActiveFilter(results, selectedFilter);

  const handleTabChange = (value: string) => {
    setSelectedFilter(value);
    getAnalyticsPlugin().track(AnalyticsEnum.CLICK_SEARCH_MODAL_CATEGORY, {
      categoria: value.toLocaleLowerCase(),
    });
  };

  return (
    <div
      className={className}
      data-testid={DataTestIdEnum.PROCEDURES_MODAL_SEARCH_FILTERS}
    >
      <FiltersTabs
        tabs={tabs}
        value={activeTab}
        onChange={handleTabChange}
      />
    </div>
  );
}
